function mediaslider(){
  var mediaslider=[];
  document.querySelectorAll('.media-slider').forEach(function(Element,index){
    var mediaid = Element.dataset.id;
    var media_autoplay = Element.dataset.autoplay;
    let swiperObject={
      loop:false,
      simulateTouch: eval(Element.dataset.draggable),
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    };
    if(eval(media_autoplay)==true){
      swiperObject.autoplay={
        delay: eval(Element.dataset.playtime)
      }
    }
    mediaslider[mediaid]=new Swiper(Element,swiperObject );
  });
  if ($(window).width() >= 768){ 
   $('.media-list').mousemove(function(e){
       var X = e.pageX;
     var Y = e.pageY - 100; 
     var color = $(this).find('.focus').attr('data-bg');
     $('.focus').css('background', 'radial-gradient(circle at '+X+'px '+Y+'px ,transparent 419px, '+color+' 421px)');
     $('.inner_focus').css({'left': X, 'top': Y-40, 'opacity': 1})
   });
  $('.media-list').mouseout(function(e){
   // $('.focus').css('background', 'radial-gradient(circle at 100px 100px ,transparent 419px, #fff 421px)');
    $('.inner_focus').css('opacity', 0)
});
  }
var offset_top = 0;
  var s_height = $('.home_hero_banner').outerHeight();
   $('.home_hero_banner .media-caption').each(function(){
        offset_top = $(this).offset().top - 55;
   });
$(window).scroll(function(){
  $('.img-parallax').each(function(){
    if ($(this).offset().top < $(window).scrollTop()) {
        var difference = $(window).scrollTop() - $(this).offset().top;
          var half = (difference / 2) + 'px',
        transform = 'translate3d( 0, ' + half + ',0)';
          $(this).css('transform', transform);
    } else {
        $(this).css('transform', 'translate3d(0,0,0)');
    }
  });

 $('.home_hero_banner .media-caption').each(function(){
        var s_top = $(window).scrollTop();
   var t_height = $(this).outerHeight();
     var total_height = s_height - t_height;
        if (s_top > offset_top){
            $(this).addClass('fixed_caption')
        }
        else{
            $(this).removeClass('fixed_caption')
        }
   if (s_top > total_height){
     $(this).addClass('unvisible');
   }
   else{
     $(this).removeClass('unvisible');
   }
 });
});
}
  
mediaslider();

$(document).on('click', '.see_width', function () {
  $('.focus').addClass('bg_transparent');
  $(this).addClass('less_width').text('Hide full image').removeClass('see_width');
});
$(document).on('click', '.less_width', function () {
  $('.focus').removeClass('bg_transparent');
  $(this).addClass('see_width').text('show full image').removeClass('less_width');
})